import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from '../../auth.service';
import { NavBarComponent } from '../../nav-bar/nav-bar.component';
import { VirtualConsultantComponent } from '../../virtual-consultant/virtual-consultant.component';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { Base } from 'src/app/services/base';



@Component({
    selector: 'app-vc-filter',
    templateUrl: './vc-filter.component.html',
    styleUrls: ['./vc-filter.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class VcFilterComponent implements OnInit {

  public tenants: any[] = [];
  public tenantId: number;

  startDate;
  endDate;

  maxDate = new Date();

  public tenantIdSubject = new BehaviorSubject<number>(null);
  tenantId$ = this.tenantIdSubject.asObservable();

  constructor(
    public nav: NavBarComponent,
    public auth: AuthService,
    public base: Base,
    public dialogRef: MatDialogRef<VirtualConsultantComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService
  ) {

    this.base.fetchVcFilter().subscribe(vcFilter => {
      if (vcFilter.vcFilter != null) {
        this.startDate = vcFilter.vcFilter.startDate;
        this.endDate = vcFilter.vcFilter.endDate;
        this.tenants = vcFilter.vcFilter.tenants;
      } else {
        if (sessionStorage.getItem("tenants") != null) {
          let tenantsTmp = JSON.parse(sessionStorage.getItem('tenants'));
  
          tenantsTmp.forEach(tenant => {
            let tenantTmp = { id: tenant.id, name: tenant.name, isChecked: true };
            this.tenants.push(tenantTmp);
            this.tenantIdSubject.next(tenant.id);
            this.tenantId = tenant.id;
          });
        } else {
          this.auth.tenants$.subscribe(tenants => {
            if (tenants != null) {
              tenants.forEach(tenant => {
                this.startDate = data.startDate;
                this.endDate = data.endDate;
                let tenantTmp = { id: tenant.id, name: tenant.name, isChecked: true };
                this.tenants.push(tenantTmp);
                this.tenantIdSubject.next(tenant.id);
                this.tenantId = tenant.id;
              });
            }
          })
        }
      }
    })

    // if (data.tenants.length == 0) {
    //   if (sessionStorage.getItem("tenants") != null) {
    //     let tenantsTmp = JSON.parse(sessionStorage.getItem('tenants'));

    //     tenantsTmp.forEach(tenant => {
    //       let tenantTmp = { id: tenant.id, name: tenant.name, isChecked: true };
    //       this.tenants.push(tenantTmp);
    //       this.tenantIdSubject.next(tenant.id);
    //       this.tenantId = tenant.id;
    //     });
    //   } else {
    //     this.auth.tenants$.subscribe(tenants => {
    //       if (tenants != null) {
    //         tenants.forEach(tenant => {
    //           this.startDate = data.startDate;
    //           this.endDate = data.endDate;
    //           let tenantTmp = { id: tenant.id, name: tenant.name, isChecked: true };
    //           this.tenants.push(tenantTmp);
    //           this.tenantIdSubject.next(tenant.id);
    //           this.tenantId = tenant.id;
    //         });
    //       }
    //     })
    //   }
    // } else {
    //   this.tenants = data.tenants;
    // }
  }

  ngOnInit(): void {
  }

  startDateChanged(event: MatDatepickerInputEvent<Date>) {
    this.startDate = event.value;
  }

  endDateChanged(event: MatDatepickerInputEvent<Date>) {
    this.endDate = event.value;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  applyFilter() {
    let vcFilter = {
      "tenants": this.tenants,
      "startDate": this.startDate,
      "endDate": this.endDate
    }
    this.base.setVcFilter(vcFilter);
    this.dialogRef.close({ "vcFilter": vcFilter });
  }

  selectAll() {
    for (let i = 0; i < this.tenants.length; i++) {
      this.tenants[i].isChecked = true;
    }
  }

  selectNone() {
    for (let i = 0; i < this.tenants.length; i++) {
      this.tenants[i].isChecked = false;
    }
  }

}
